interface CTABannerProps {
  onScrollTo: (id: string) => void;
}

export default function CTABanner({ onScrollTo }: CTABannerProps) {
  return (
    <section className="py-10 sm:py-12 bg-gradient-to-r from-yellow-500 to-yellow-600 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-40 h-40 bg-black rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-60 h-60 bg-black rounded-full translate-x-1/3 translate-y-1/3"></div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center relative z-10">
        <p className="text-black font-black text-xl sm:text-2xl md:text-3xl mb-2">
          Não precisa experiência.
        </p>
        <p className="text-black/80 text-sm sm:text-base md:text-lg mb-5 sm:mb-6 font-medium">
          Buscamos talentos naturais. Sua oportunidade começa aqui.
        </p>
        <button
          onClick={() => onScrollTo('inscricao')}
          className="bg-black text-yellow-500 px-8 sm:px-10 py-3 sm:py-4 rounded-full text-sm sm:text-base font-bold hover:bg-gray-900 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          INSCREVA-SE AGORA
        </button>
      </div>
    </section>
  );
}
